<script>
  import Vue from 'vue'

  // Renderless component to out Raw HTML without a wrapper
  // Taken from https://jsfiddle.net/Linusborg/mfqjk5hm/
  export default {
    functional: true,
    props: ['html'],
    render(h, ctx) {
      const nodes = new Vue({
        beforeCreate() {
          this.$createElement = h
        }, // not necessary, but cleaner imho
        template: `<div>${ctx.props.html}</div>`
      }).$mount()._vnode.children
      return nodes
    }
  }
</script>
